import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useCheckbox } from '@react-aria/checkbox';
import { useToggleState } from '@react-stately/toggle';
import { CheckboxInternal } from './CheckboxInternal';
export function Checkbox(props) {
  const ref = React.useRef();
  const state = useToggleState(props);
  const {
    inputProps
  } = useCheckbox(props, state, ref);
  return /*#__PURE__*/React.createElement(CheckboxInternal, _extends({}, props, {
    isSelected: state.isSelected,
    inputProps: inputProps,
    inputRef: ref
  }));
}